






































































import { Component, Mixins } from 'vue-property-decorator'
import { checkAndFetchlibrary } from '@/helpers/library'
import { LibraryMixin } from '@/mixins'

@Component({
  components: {
    Statistics: require('./Statistics').default
  }
})
export default class Dashboard extends Mixins(LibraryMixin) {
  get isDemoUser(): boolean {
    return this.$store.state.auth.isDemoUser
  }

  async refreshLibrary(e: MouseEvent) {
    if (e.shiftKey) {
      this.$store.commit('library/reset')
    }

    await checkAndFetchlibrary(true)
  }

  async signOut() {
    await this.$store.dispatch('auth/logout')
  }
}
